
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community-guidelines",
      function () {
        return require("private-next-pages/community-guidelines.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community-guidelines"])
      });
    }
  